import { Button, Col, Container, Modal, Row, Stack } from "react-bootstrap";
import AccordionComponent from "../../../common/Accordion";
import SearchableSingleSelectDropdown from "../../../common/SearchableDropdown";
import { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  fetchDocumentCategory,
  fetchDocumentCategoryList,
  getDownloadFileForPopUpDetails,
} from "../../../services/UploadRecordsApi";
import {
  addShareRecordsDetails,
  fetchCaseIDList,
  getShareRecordDetails,
  getShareRecordDownloadHistory,
  showFilesList,
  updateShareRecordsDetails,
} from "../../../services/SharedRecordsApi";
import { downloadQMEFormsZip } from "../../../services/AppointmentsAPI";

import { ShowFilesHeader } from "../actions/Constant";
import DataTable from "../../../common/DataTable";
import Snackbar from "../../../common/Snackbar";
import { dateTimeFormatted, formatDateTime } from "../../../utils/dateUtils";
import DatePickerWithTime from "../../../common/DatePickerWithTime";
import MultilineTextBox from "../../../common/MultilineTextBox";
import TeamMultipleDropdown from "../../../common/TeamMultipleDropdown";
import {
  getEmployeeNameforTeam,
  getEmployeeNameforTeamByCaseID,
} from "../../Master/Teams/action/fetchTeamsData";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/Store";
import moment from "moment";
import SingleTagInputField from "../../../common/SingleTagInputField";
import Loader from "../../../common/Loader";
import { SHARE_RECORDS_STATUS } from "../../../common/Constant";
import { shareRecordValidations } from "../actions/shareRecordsValidations";
import FloatingLabelDatepicker from "../../../common/DatePicker";
import TimePicker from "../../../common/TimePicker";
import { useFeatureAccess } from "../../../hooks/useFeatureAccess";
import { SHARED_BY_ME_ACTIONS } from "../../../common/EventConstant";
import UploadStatusFloatingIcon from "../../../common/UploadStatusFloatingIcon";

interface Option {
  tenantId: number;
  caseInfoId: number;
  caseSubjectId: number;
  caseId: string;
  claimNumber: string;
  subjectFullName: string;
  customerAccountNo: string,
}

interface UploadRecordResult {
  tenantId: number;
  caseInfoId: number;
  caseRecordHeaderId: number;
  documentTypeId: number;
  documentTypeName: string;
  documentCategory: string;
  caseRecordDetailsId: number;
  fileName: string;
  cloudLocation: string;
  description: string;
  uploadedByName: string;
  detailCreatedDate: string;
}

interface EmployeeData {
  userid: number;
  userfullname: string;
  userTypeName: string;
}

interface GroupedOption {
  group: string;
  options: { label: string; value: number; disabled?: boolean }[];
}

interface ShareRecordCreateProps {
  selectedRowData: any;
  onTabChange: () => void;
  headerActiveTab: string;
  actionsAccess: any;
}

const CreateShareRecords: React.FC<ShareRecordCreateProps> = ({
  selectedRowData,
  onTabChange,
  headerActiveTab,
  actionsAccess,
}) => {
  const isDisable =
    selectedRowData?.status === SHARE_RECORDS_STATUS.EXPIRED ||
    selectedRowData?.status === SHARE_RECORDS_STATUS.REVOKED ||
    selectedRowData?.actions?.View === "View";
  const datePickerRef = useRef<HTMLDivElement>(null);
  const { caseid, claimnumber, status, caseStage, caseInfoId } = useSelector(
    (state: RootState) => state.caseHeader,
  );
  const loggedInUserid = useSelector((state: RootState) => state.auth.userid);
  const [activeKeys, setActiveKeys] = useState<string[]>(["0"]);
  const [activeKeysShareDetails, setActiveKeysShareDetails] = useState<
    string[]
  >(!selectedRowData?.shareId ? ["0"] : []);
  const [caseIdOptions, setCaseIdOptions] = useState<any[]>([]);
  const [documentCategoryOptions, setDocumentCategoryOptions] = useState<any[]>(
    [],
  );
  const [documentTypeOptions, setDocumentTypeOptions] = useState<any[]>([]);
  const [contactUserOptions, setContactUserOptions] = useState<GroupedOption[]>(
    [],
  );
  const [caseId, setCaseId] = useState<string | null | number>(null);
  const [documentCategory, setDocumentCategory] = useState<
    string | null | number
  >(null);
  const [documentType, setDocumentType] = useState<string | null | number>(
    null,
  );
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchQueryNew, setSearchQueryNew] = useState<string>("");
  const [filteredResults, setFilteredResults] = useState<Option[]>([]);
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);
  const [fileList, setFileList] = useState<UploadRecordResult[]>([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [isFileShow, setIsFileShow] = useState(false);
  const [expirationDateTime, setExpirationDateTime] = useState<Date | null>(
    new Date(),
  );
  const [selectedEmployee, setSelectedEmployee] = useState<any[]>([]);
  const [addedEmployee, setAddedEmployee] = useState<any[]>([]);
  const [isShareWith, setIsShareWith] = useState<boolean>(true);
  const [isSetExpirationLimit, setIsSetExpirationLimit] =
    useState<boolean>(false);
  const [selectedCaseRecordDetailsIds, setSelectedCaseRecordDetailsIds] =
    useState<string[]>([]);
  const [emailAddress, setEmailAddress] = useState<string[]>([]);
  const [emailAddressList, setEmailAddressList] = useState<string[]>([]);
  const [showMessagePopUp, setShowMessagePopUp] = useState<boolean>(false);
  const [shareNotes, setShareNotes] = useState<string>("");
  const [shareRecordDetails, setShareRecordDetails] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [showModalNew, setShowModalNew] = useState(false);
  const [downloadStatuses, setDownloadStatuses] = useState<any>({});
  const latestRequestRef = useRef(0);
  const lastFetchedIdRef = useRef(null);
  const [cancelSource, setCancelSource] = useState<
    "cancel1" | "cancel2" | null
  >(null);
  const [startTime, setStartTime] = useState<any>("18:00");

  const hasSharedByMe = actionsAccess.includes("Shared By Me");
  const hasEdit = actionsAccess.includes("Edit");
  const hasShareRecords = actionsAccess.includes("Share Records");
  const hasRevokeAction = actionsAccess.includes("Revoke Action");
  const hasRecordDetails = actionsAccess.includes("Record Details");
  const hasShareInternal = actionsAccess.includes("Share Internal");
  const hasShareExternal = actionsAccess.includes("Share External");
  const hasShareExpiration = actionsAccess.includes("Share Expiration");
  const hasEditRecordDetails = actionsAccess.includes("Edit Record Details");

  const getStatusColor = (status: string) => {
    switch (status) {
      case SHARE_RECORDS_STATUS.ACTIVE:
        return 'text-success'; 
      case SHARE_RECORDS_STATUS.REVOKED:
        return 'text-danger'; 
      case SHARE_RECORDS_STATUS.EXPIRED:
        return 'text-secondary'; 
      default:
        return 'text-secondary'; 
    }
  };

  const fetchData = async (caseInfoId?: number) => {
    try {
      const documentTypeList = await fetchDocumentCategoryList();
      const documentCategoryList = await fetchDocumentCategory();

      setDocumentTypeOptions(documentTypeList || []);
      setDocumentCategoryOptions(documentCategoryList || []);

      const employeeData: EmployeeData[] =
        await getEmployeeNameforTeamByCaseID(caseInfoId);

      const filteredEmployeeData = employeeData.filter(
        (employee) => employee.userid !== loggedInUserid,
      );

      const groupedData = filteredEmployeeData.reduce<
        Record<string, GroupedOption>
      >((groups, employee) => {
        const {
          userTypeName: group,
          userfullname: label,
          userid: value,
        } = employee;

        if (!groups[group]) {
          groups[group] = { group, options: [] };
        }

        groups[group].options.push({
          label,
          value,
          disabled: value === loggedInUserid,
        });

        return groups;
      }, {});

      const transformedOptions = Object.values(groupedData);
      setContactUserOptions(transformedOptions);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // useEffect(() => {
  //   fetchData();
  // }, []);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node) &&
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target as Node)
      ) {
        setFilteredResults([]);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const fetchShareRecordData = async () => {
    const shareId = selectedRowData?.shareId;
    setLoading(true); 
    if (!shareId || lastFetchedIdRef.current === shareId) return;
    lastFetchedIdRef.current = shareId;

    const requestId = ++latestRequestRef.current;
    try {
      const response = await getShareRecordDetails(selectedRowData?.shareId);
      const shareData = response?.result;
      if (!shareData || requestId !== latestRequestRef.current) return;
      if (shareData) {
        setIsFileShow(true);
        setShareRecordDetails([shareData]);
        await fetchData(shareData.caseInfoId);
        const shareToUseridString = shareData?.sharedToUserDetail
          ?.map((user: { sharedToUserID: any }) => user.sharedToUserID)
          .join(", ");
        const sharedFileIds =
          shareData.sharedFileIds?.split(",").filter(Boolean) || [];

        setSelectedOption({
          tenantId: shareData.tenantId,
          caseInfoId: shareData.caseInfoId,
          caseSubjectId: 0,
          caseId: shareData.caseId,
          claimNumber: shareData.claimNumber,
          subjectFullName: shareData.subjectFullName,
          customerAccountNo: shareData?.customerAccountNo,
        });
        setSearchQuery(
          `${shareData.subjectFullName} | ${shareData.claimNumber}`,
        );
        setSearchQueryNew(
          `${shareData.subjectFullName} | ${shareData.claimNumber}`,
        );
        setShareNotes(shareData.sharingNote || "");
        setIsShareWith(shareData.shareType === "Internal");
        setIsSetExpirationLimit(shareData.expiryDate ? true : false);
        setExpirationDateTime(
          shareData.expiryDate ? new Date(shareData.expiryDate) : null,
        );
        const timeOnly = shareData?.expiryDate
          ? moment(shareData.expiryDate).format("HH:mm")
          : "";
        setStartTime(timeOnly || "");
        setSelectedCaseRecordDetailsIds(sharedFileIds);
        if (shareData.shareType === "Internal") {
          setSelectedEmployee(
            shareToUseridString?.split(",").map(Number) || [],
          );
          setAddedEmployee(shareToUseridString?.split(",").map(Number) || []);
        } else {
          setEmailAddressList(
            Array.isArray(shareData.sharedToEmails)
              ? shareData.sharedToEmails
              : shareData.sharedToEmails?.split(",") || [],
          );
        }
        const cleanSharedFileIds = sharedFileIds.map((id: any) => id.trim());
        const payload = {
          caseInfoId: shareData.caseInfoId,
          documentCategory,
          documentTypeId: documentType,
        };
        const response = await showFilesList(payload);
        if (Array.isArray(response?.result)) {
          const updatedList = response?.result
            ?.filter((item) =>
              shareData.shareStatus === SHARE_RECORDS_STATUS.ACTIVE &&
              headerActiveTab !== "Shared With Me"
                ? true
                : cleanSharedFileIds.includes(
                    String(item?.caseRecordDetailsId),
                  ),
            )
            ?.map((item) => ({
              ...item,
              id: item?.caseRecordDetailsId,
              fileNameShareRecord: item?.fileName,
              uploadedByName_Date: `${item.uploadedByName} ${dateTimeFormatted(
                item.detailCreatedDate,
              )}`,
              download: item?.cloudLocation,
            }));
          setFileList(updatedList);
        } else {
          setFileList([]);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      if (requestId === latestRequestRef.current) {
        setLoading(false); 
      }
    }
  };

  useEffect(() => {
    if (selectedRowData?.shareId) {
      fetchShareRecordData();
    }
  }, [selectedRowData]);

  const renderAccordionRecordDetails = (
    items: { key: string; title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map(({ key, title, content }) => ({
        title: <>{title}</>,
        content,
        eventKey: key,
      }))}
      activeKey={activeKeys}
      onSelect={(key) => {
        setActiveKeys((prevKeys) =>
          prevKeys.includes(key as string)
            ? prevKeys.filter((k) => k !== key)
            : [key as string],
        );
      }}
    />
  );

  const renderAccordionShareDetails = (
    items: { key: string; title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map(({ key, title, content }) => ({
        title: <>{title}</>,
        content,
        eventKey: key,
      }))}
      activeKey={activeKeysShareDetails}
      onSelect={(key) => {
        setActiveKeysShareDetails((prevKeys) =>
          prevKeys.includes(key as string)
            ? prevKeys.filter((k) => k !== key)
            : [key as string],
        );
      }}
    />
  );

  const handleSearchChange = async (e: ChangeEvent<HTMLInputElement>) => {
    const query = e.target.value;
    if (query.startsWith(" ")) {
      return;
    }
    setSearchQuery(query);
    const trimmedQuery = query.trim();
    if (trimmedQuery.length < 3) {
      setFilteredResults([]);
      return;
    }

    try {
      const response: any = await fetchCaseIDList(trimmedQuery);
      if (Array.isArray(response.result)) {
        setFilteredResults(response.result);
      } else {
        setFilteredResults([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleSelect = (option: Option) => {
    setSelectedOption(option);
    setSearchQuery(
      `${option.customerAccountNo || ""} | ${option.claimNumber || ""} | ${
        option.subjectFullName || ""
      }`.trim(),
    );
    setFilteredResults([]);
    fetchData(option.caseInfoId);
  };

  const handleShowFiles = async () => {
    if (!selectedOption?.caseInfoId) {
      setSnackbarMessage("Please select Case ID");
      setError("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      const payload = {
        caseInfoId: selectedOption?.caseInfoId ?? null,
        documentCategory,
        documentTypeId: documentType,
      };
      const response = await showFilesList(payload);
      if (Array.isArray(response.result)) {
        const updatedList = response.result.map((item) => ({
          ...item,
          id: item?.caseRecordDetailsId,
          fileNameShareRecord: item?.fileName,
          uploadedByName_Date: `${item.uploadedByName} ${dateTimeFormatted(
            item.detailCreatedDate,
          )}`,
          download: item?.cloudLocation,
        }));
        setIsFileShow(true);
        setFileList(updatedList);
      } else {
        setFileList([]);
      }
    } catch (error) {
      console.error("Failed to fetch files:", error);
    }
  };

  useEffect(() => {
    if (cancelSource === "cancel1" && selectedRowData?.shareId) {
      handleShowFiles();
    }
  }, [searchQueryNew, documentCategory, documentType]);

  const handleCheckbox = (row: any) => {
    const ids = row
      ?.map((r: any) => String(r?.caseRecordDetailsId))
      ?.filter(Boolean);
    setSelectedCaseRecordDetailsIds(ids);
  };

  const fetchSingleDownloadFile = async (
    caserecorddetailsId: number,
    fileName: string,
  ) => {
    try {
      setShowMessagePopUp(true);
      const hideMessageTimeout = setTimeout(() => {
        setShowMessagePopUp(false);
      }, 3000);
     
      const fileData = await getDownloadFileForPopUpDetails(
        caserecorddetailsId,
        fileName,
      );

      if (headerActiveTab === "Shared With Me" && selectedRowData?.shareId) {
        const fileDataHistory = await getShareRecordDownloadHistory(
          caserecorddetailsId,
          selectedRowData?.shareId
        );
      }

      clearTimeout(hideMessageTimeout);
      setShowMessagePopUp(false);
    } catch (error) {
      console.error("Error fetching single download file data:", error);
      setShowMessagePopUp(false);
    }
  };

  const handleDownloadProgress = async (
    id: string,
    downloadFn: () => Promise<any>,
    fileName: string = "File.zip",
  ) => {
    setDownloadStatuses((prev: any) => ({
      ...prev,
      [id]: { fileName, progress: 0, isUploading: true },
    }));

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 90) return;
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress },
      }));
    }, 300);

    try {
      await downloadFn();
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], progress: 100, isUploading: false },
      }));
      setTimeout(() => {
        setDownloadStatuses((prev: any) => {
          const updated = { ...prev };
          delete updated[id];
          return updated;
        });
      }, 2000);
    } catch (error) {
      console.error("Download error:", error);
      clearInterval(interval);
      setDownloadStatuses((prev: any) => ({
        ...prev,
        [id]: { ...prev[id], isUploading: false },
      }));
    }
  };

  const handleDownloadAction = (row: any) => {
    handleDownloadProgress(`doc-${Date.now()}`, () =>
      fetchSingleDownloadFile(row?.caseRecordDetailsId, row?.fileName),
      row?.fileName,
    );
  };

  const handle110DownloadAction = async(row: any) => {
    try {
      setShowMessagePopUp(true);
      const hideMessageTimeout = setTimeout(() => {
        setShowMessagePopUp(false);
      }, 3000);
      const fileData = await downloadQMEFormsZip([row.subjectQmeScheduleId]);

      clearTimeout(hideMessageTimeout);
      setShowMessagePopUp(false);
    } catch (error) {
      console.error("Error fetching while download file data:", error);
      setShowMessagePopUp(false);
    }
  };
  const handleAdd = () => {
    // Filter out already-added employees to prevent duplicates
    const newEmployees = selectedEmployee.filter(
      (emp) => !addedEmployee.includes(emp),
    );
    setAddedEmployee([...addedEmployee, ...newEmployees]);
    setSnackbarMessage("Contact User added successfully.");
    setError("success");
    setSnackbarOpen(true);
  };

  const handleRemove = (employee: any) => {
    setAddedEmployee(addedEmployee.filter((e) => e !== employee));
    setSelectedEmployee(selectedEmployee.filter((e) => e !== employee));
    setSnackbarMessage("Contact User has been deleted.");
    setError("success");
    setSnackbarOpen(true);
  };

  const handleCancel = () => {
    // Keep only selected values that are already added
    const stillSelected = selectedEmployee.filter((emp) =>
      addedEmployee.includes(emp),
    );

    setSelectedEmployee(stillSelected);
  };

  const validateData = () => {
    const validationErrors = shareRecordValidations(
      isSetExpirationLimit,
      expirationDateTime,
      startTime,
      isShareWith,
      selectedEmployee,
      emailAddressList,
      selectedCaseRecordDetailsIds,
      selectedOption?.caseInfoId,
    );

    if (validationErrors.length > 0) {
      setSnackbarMessage(validationErrors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (validateData()) {
      const commaSeparatedCaseRecordDetailsIds =
        selectedCaseRecordDetailsIds.join(",");
      const commaSeparatedSelectedEmployeeIds = selectedEmployee.join(",");
      // const formattedDate = expirationDateTime
      //   ? moment(expirationDateTime).format("YYYY-MM-DDTHH:mm:ss")
      //   : "";
      const formattedDate =
        expirationDateTime && startTime
          ? moment(
              `${moment(expirationDateTime).format("YYYY-MM-DD")} ${moment(
                startTime,
                ["HH:mm", "HH:mm:ss"],
              ).format("HH:mm:ss")}`,
              "YYYY-MM-DD HH:mm:ss",
            ).format("YYYY-MM-DDTHH:mm:ss")
          : "";
      const commaSeparatedSelectedemailAddress = emailAddressList.join(",");

      const payloadAdd = {
        shareId: selectedRowData?.shareId ? selectedRowData?.shareId : 0,
        caseInfoId: selectedOption?.caseInfoId ?? null,
        sharedByUserId: loggedInUserid,
        sharingNote: shareNotes,
        shareType: isShareWith ? "Internal" : "External",
        expiryDate: isSetExpirationLimit ? formattedDate : null,
        sharedToUserIds: isShareWith ? commaSeparatedSelectedEmployeeIds : null,
        sharedToEmails: !isShareWith
          ? commaSeparatedSelectedemailAddress
          : null,
        caseRecordDetailsIds: commaSeparatedCaseRecordDetailsIds,
        createdBy: loggedInUserid,
        modifiedBy: loggedInUserid,
      };

      try {
        setLoading(true);
        let response;
        if (selectedRowData?.shareId) {
          response = await updateShareRecordsDetails(payloadAdd);
        } else {
          response = await addShareRecordsDetails(payloadAdd);
        }
        if (response?.isSuccess) {
          setSnackbarMessage(
            selectedRowData?.shareId
              ? "Records shared successfully."
              : "Records shared successfully.",
          );
          setError("success");
          setSnackbarOpen(true);
          setTimeout(() => {
            onTabChange();
          }, 1000);
        } else {
          setSnackbarMessage(response?.message || "Failed to process data.");
          setError("error");
          setSnackbarOpen(true);
        }
      } catch (error) {
        console.error("Error processing data:", error);
        setSnackbarMessage("An error occurred while processing the data.");
        setSnackbarOpen(true);
        setError("error");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleRemoveEmails = (index: number) => {
    const updatedList = emailAddressList.filter((_, i) => i !== index);
    setEmailAddressList(updatedList);
  };

  const handleBack = () => {
    onTabChange();
  };

  const resetData = () => {
    setCaseIdOptions([]);
    setDocumentCategoryOptions([]);
    setDocumentTypeOptions([]);
    setContactUserOptions([]);
    setCaseId(null);
    setDocumentCategory(null);
    setDocumentType(null);
    setSearchQuery("");
    setFilteredResults([]);
    setSelectedOption(null);
    setFileList([]);
    setExpirationDateTime(new Date());
    setSelectedEmployee([]);
    setAddedEmployee([]);
    setIsShareWith(true);
    setIsSetExpirationLimit(false);
    setSelectedCaseRecordDetailsIds([]);
    setEmailAddress([]);
    setEmailAddressList([]);
    setShareNotes("");
    setShareRecordDetails([]);
  };

  const handleConfirmCancelButton = async () => {
    if (cancelSource === "cancel1") {
      if (selectedRowData?.shareId) {
        setDocumentCategory(null);
        setDocumentType(null);
        setSearchQuery(searchQueryNew);
        handleShowFiles();
        if (selectedRowData?.shareId) {
          await fetchShareRecordData();
        }
      } else {
        setCaseIdOptions([]);
        setIsFileShow(false);
        setCaseId(null);
        setFileList([]);
        setDocumentCategory(null);
        setDocumentType(null);
        setSearchQuery("");
        setFilteredResults([]);
        setSelectedOption(null);
      }
    } else if (cancelSource === "cancel2") {
      if (selectedRowData?.shareId) {
        await fetchShareRecordData();
      } else {
        resetData();
      }
    }

    setCancelSource(null);
    setShowModalNew(false);
  };

  const handleCancelButton = (source: "cancel1" | "cancel2") => {
    setCancelSource(source);

    setShowModalNew(true);
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleStartTimeChange = (time: string) => {
    setStartTime(time);
  };

  useEffect(() => {
    if (selectedRowData?.shareId) {
      fetchShareRecordData();
    }
  }, [selectedRowData]);

  return (
    <>
      <Container fluid className="pb-5 pt-4">
        <Loader isLoading={loading} />
        <Snackbar
          message={snackbarMessage}
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />

        <UploadStatusFloatingIcon
          uploadStatuses={downloadStatuses}
          isUpload={false}
          onCancelUpload={(id) => {
            setDownloadStatuses((prev: any) => {
              const updated = {...prev};
              delete updated[id];
              return updated;
            });
          }}
        />

        {(hasEdit || hasRecordDetails || hasEditRecordDetails) && (
          <>
            {renderAccordionRecordDetails([
              {
                key: "Records_Details",
                title: "Record Details",
                content: (
                  <>
                    <Row>
                      <Col md={6}>
                        <div className="form-floating" ref={dropdownRef}>
                          <input
                            type="text"
                            name="caseID"
                            className="form-control zipcodeDetailsOverlay"
                            placeholder="Case ID"
                            value={searchQuery}
                            maxLength={100}
                            onChange={handleSearchChange}
                            required
                            disabled={selectedRowData?.shareId || isDisable}
                          />
                          <label>
                            Patient Account No.
                            <span style={{ color: "red" }}> *</span>
                          </label>
                          {filteredResults.length > 0 && (
                            <div className="dropdown-results">
                              <ul
                                className="list-group"
                                style={{
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                }}
                              >
                                <li
                                  className="list-group-item d-flex justify-content-between align-items-center"
                                  style={{ fontWeight: "bold" }}
                                >
                                  <div style={{ width: "10%" }}>Select</div>
                                  <div style={{ width: "30%" }}>Patient Account No.</div>
                                  <div style={{ width: "30%" }}>Claim#</div>
                                  <div style={{ width: "30%" }}>
                                    Patient Name
                                  </div>
                                </li>
                                {filteredResults.map((option) => (
                                  <li
                                    key={option.caseId}
                                    className="list-group-item d-flex justify-content-between align-items-center"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleSelect(option)}
                                  >
                                    <div style={{ width: "10%" }}>
                                      <input
                                        type="radio"
                                        name="location"
                                        checked={
                                          selectedOption?.customerAccountNo ===
                                          option.customerAccountNo
                                        }
                                        onChange={() => handleSelect(option)}
                                      />
                                    </div>
                                    <div style={{ width: "30%" }}>
                                      {option.customerAccountNo}
                                    </div>
                                    <div style={{ width: "30%" }}>
                                      {option.claimNumber}
                                    </div>
                                    <div style={{ width: "30%" }}>
                                      {option.subjectFullName}
                                    </div>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </Col>
                      {headerActiveTab !== "Shared With Me" &&
                      (hasEdit || hasShareRecords) ? (
                        <>
                          <Col sm={3} className="selection_dropdown">
                            <SearchableSingleSelectDropdown
                              label="Document Category"
                              name="documentCategory"
                              options={documentCategoryOptions}
                              value={documentCategory}
                              onChange={(e, name, value) => {
                                setDocumentCategory(value);
                              }}
                              disabled={isDisable}
                              selectOption={true}
                            />
                          </Col>
                          <Col sm={3} className="selection_dropdown">
                            <SearchableSingleSelectDropdown
                              label="Document Type"
                              name="documentType"
                              options={documentTypeOptions}
                              value={documentType}
                              onChange={(e, name, value) => {
                                setDocumentType(value);
                              }}
                              disabled={isDisable}
                              selectOption={true}
                            />
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                    </Row>

                    {headerActiveTab !== "Shared With Me" ? (
                      <>
                        <Row className="mt-2 align-items-center">
                          <Col>
                            <h5 className="sectionTitle"></h5>
                          </Col>
                        </Row>
                        <Row className="mb-1 mt-1">
                          <div className="d-flex justify-content-start align-items-center gap-2 col-9">
                            {selectedRowData?.sharedBy && (
                              <>
                                <span style={{ fontSize: "14px" }}>
                                  <span style={{ fontWeight: 500 }}>
                                    Shared By | On :
                                  </span>{" "}
                                  {selectedRowData?.sharedBy}
                                </span>

                                <span style={{ fontSize: "14px" }}>
                                  {dateTimeFormatted(selectedRowData?.sharedOn)}
                                </span>

                                <span
                                  className="ms-4"
                                  style={{ fontSize: "14px" }}
                                >
                                  <span style={{ fontWeight: 500 }}>
                                    Status :
                                  </span>{" "}
                                  <span
                                    className={getStatusColor(
                                      selectedRowData?.status,
                                    )}
                                  >
                                    {selectedRowData?.status}
                                  </span>
                                </span>
                              </>
                            )}
                          </div>

                          <div className="d-flex justify-content-end col-3">
                            <Button
                              variant="outline-info"
                              className="d-flex align-items-center"
                              onClick={() => handleCancelButton("cancel1")}
                              disabled={isDisable}
                            >
                              <span className="material-icons mr-2">close</span>{" "}
                              Cancel
                            </Button>
                            <Button
                              variant="primary"
                              className="ml-3 d-flex align-items-center mx-2"
                              onClick={handleShowFiles}
                              disabled={isDisable}
                            >
                              <span className="material-icons mx-1">
                                visibility
                              </span>{" "}
                              Show Files
                            </Button>
                          </div>
                        </Row>
                      </>
                    ) : (
                      ""
                    )}
                    {isFileShow ? (
                      <>
                        {headerActiveTab !== "Shared With Me" ? (
                          <Row className="mt-3 align-items-center">
                            <Col>
                              {" "}
                              <h5 className="sectionTitle">List</h5>{" "}
                            </Col>
                          </Row>
                        ) : (
                          <Row className="mt-3">
                            <div className="col-12">
                              {selectedRowData?.sharedBy && (
                                <div
                                  className="d-flex align-items-center gap-3"
                                  style={{ fontSize: "14px" }}
                                >
                                  <span>
                                    <span style={{ fontWeight: 500 }}>
                                      Shared By | On :
                                    </span>{" "}
                                    {selectedRowData?.sharedBy}
                                  </span>

                                  <span>
                                    {dateTimeFormatted(
                                      selectedRowData?.sharedOn,
                                    )}
                                  </span>

                                  <span>
                                    <span style={{ fontWeight: 500 }}>
                                      Status :
                                    </span>{" "}
                                    <span
                                      className={getStatusColor(
                                        selectedRowData?.status,
                                      )}
                                    >
                                      {selectedRowData?.status}
                                    </span>
                                  </span>
                                </div>
                              )}
                              <h5 className="sectionTitle mt-2">List</h5>
                            </div>
                          </Row>
                        )}

                        <DataTable
                          headers={ShowFilesHeader}
                          rows={fileList}
                          isCheckbox={true}
                          onDownloadAction={handleDownloadAction}
                          on110DownloadAction={handle110DownloadAction}
                          onCheckboxSelect={handleCheckbox}
                          selectedRowIds={selectedCaseRecordDetailsIds}
                          disabled={isDisable}
                        />
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ),
              },
            ])}
          </>
        )}
        {headerActiveTab !== "Shared With Me" &&
        (hasEdit || hasShareRecords) ? (
          <>
            {renderAccordionShareDetails([
              {
                key: "Share_Details",
                title: "Share Details",
                content: (
                  <>
                    <Row>
                      <Col sm={6} className="d-flex align-items-center">
                        <div className="d-flex align-items-center gap-3">
                          <label className="me-2 fw-bold">
                            Share With <span style={{ color: "red" }}>*</span>
                          </label>

                          {hasShareInternal && (
                            <label className="d-flex align-items-center">
                              <input
                                type="radio"
                                name="internal"
                                checked={isShareWith === true}
                                onChange={() => setIsShareWith(true)}
                                className="me-1"
                                disabled={selectedRowData?.shareId || isDisable}
                              />
                              Internal
                            </label>
                          )}

                          {hasShareExternal && (
                            <label className="d-flex align-items-center">
                              <input
                                type="radio"
                                name="external"
                                checked={isShareWith === false}
                                onChange={() => setIsShareWith(false)}
                                className="me-1"
                                disabled={selectedRowData?.shareId || isDisable}
                              />
                              External
                            </label>
                          )}
                        </div>
                      </Col>
                      {hasShareExpiration && (
                        <Col sm={2} className="d-flex align-items-center my-4">
                          <label className="d-flex align-items-center">
                            <input
                              type="checkbox"
                              name="expirationLimit"
                              checked={isSetExpirationLimit}
                              onChange={(e) =>
                                setIsSetExpirationLimit(e.target.checked)
                              }
                              className="me-1"
                              disabled={isDisable}
                            />
                            Set Expiration Limit
                          </label>
                        </Col>
                      )}

                      <Col sm={4} className="d-flex align-items-center">
                        {isSetExpirationLimit ? (
                          <>
                            {/* <DatePickerWithTime
                            ref={datePickerRef}
                            label="Expiration Date"
                            name="expirationDateTime"
                            value={expirationDateTime}
                            onChange={(date: Date | null) => {
                              setExpirationDateTime(date);
                            }}
                            required
                            dateFormat="MM/dd/yyyy  HH:mm"
                            disabled={!isSetExpirationLimit || isDisable}
                            minDate={new Date()}
                          /> */}
                            <Row>
                              <Col>
                                <FloatingLabelDatepicker
                                  ref={datePickerRef}
                                  label="Expiration Date"
                                  name="expirationDateTime"
                                  value={expirationDateTime}
                                  onChange={(date: Date | null) => {
                                    setExpirationDateTime(date);
                                    setStartTime("");
                                  }}
                                  required
                                  dateFormat="MM/dd/yyyy"
                                  disabled={!isSetExpirationLimit || isDisable}
                                  minDate={new Date()}
                                />
                              </Col>
                              <Col>
                                <TimePicker
                                  selectedTime={startTime}
                                  onChange={handleStartTimeChange}
                                  disabled={!isSetExpirationLimit || isDisable}
                                  label="Time"
                                  required
                                  date={expirationDateTime}
                                />
                              </Col>
                            </Row>
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                    <Row className="mt-1 align-items-center">
                      <Col sm={12}>
                        <h5 className="sectionTitle">
                          {isShareWith && hasShareInternal
                            ? "Contact User"
                            : "Email ID"}
                        </h5>
                      </Col>
                    </Row>
                    <Row>
                      {isShareWith && hasShareInternal ? (
                        <Col sm={12}>
                          <div
                            className="teams table-responsive"
                            style={{
                              maxHeight: "inherit",
                              overflow: "inherit",
                            }}
                          >
                            <table className="table table-bordered team_grid">
                              <thead className="thead-dark">
                                <tr>
                                  <th style={{ width: "95%" }}>User</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <TeamMultipleDropdown
                                      label="Select Users"
                                      options={contactUserOptions}
                                      values={selectedEmployee}
                                      onChange={setSelectedEmployee}
                                      style={{ width: "100%" }}
                                      disabled={isDisable || !selectedOption}
                                    />
                                  </td>
                                  <td className="text-center d-flex">
                                    <Button
                                      variant="outline-primary"
                                      className="d-flex align-items-center justify-content-left "
                                      onClick={handleAdd}
                                      disabled={
                                        selectedEmployee?.length === 0 ||
                                        isDisable
                                      }
                                    >
                                      <span className="material-symbols-outlined me-0">
                                        add_circle
                                      </span>
                                      Add
                                    </Button>
                                    <Button
                                      variant="danger"
                                      className="border-0 bg-transparent"
                                      onClick={handleCancel}
                                      disabled={isDisable}
                                    >
                                      <span className="material-icons color_brand">
                                        close
                                      </span>
                                    </Button>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div
                            className="teams table-responsive"
                            style={{ maxHeight: "inherit" }}
                          >
                            <table className="table table-bordered team_grid">
                              <tbody>
                                {addedEmployee.map((empId, index) => {
                                  const group = contactUserOptions.find((g) =>
                                    g.options.some(
                                      (opt) => opt.value === empId,
                                    ),
                                  );
                                  const user = group?.options.find(
                                    (opt) => opt.value === empId,
                                  );
                                  const groupInitial = group?.group
                                    ?.charAt(0)
                                    .toUpperCase();

                                  return (
                                    <tr key={index}>
                                      <td style={{ width: "93%" }}>
                                        {groupInitial && user?.label ? (
                                          <span className="d-flex align-items-center gap-2">
                                            <span
                                              className="circleTeam"
                                              title={group?.group}
                                              style={{
                                                width: "24px",
                                                height: "24px",
                                                borderRadius: "50%",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                backgroundColor: "#007bff",
                                                color: "#fff",
                                                fontWeight: 600,
                                                fontSize: "14px",
                                              }}
                                            >
                                              {groupInitial}
                                            </span>
                                            {user.label}
                                          </span>
                                        ) : (
                                          "-"
                                        )}
                                      </td>
                                      <td className="text-center">
                                        <Button
                                          variant="link"
                                          onClick={() => handleRemove(empId)}
                                          className="p-0"
                                          style={{ color: "red" }}
                                          disabled={isDisable}
                                        >
                                          <span className="material-icons">
                                            close
                                          </span>
                                        </Button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        </Col>
                      ) : (
                        <Col sm={6}>
                          <div
                            className="teams table-responsive"
                            style={{
                              overflow: "visible",
                              maxHeight: "inherit",
                            }}
                          >
                            <table className="table table-bordered team_grid">
                              <thead className="thead-dark">
                                <tr>
                                  <th style={{ width: "90%" }}>User Email</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>
                                    <SingleTagInputField
                                      label="Email Address"
                                      value={emailAddress}
                                      onChange={(newVal) => {
                                        if (
                                          newVal.length > emailAddress.length
                                        ) {
                                          const newTag = newVal.find(
                                            (tag) =>
                                              !emailAddress.includes(tag),
                                          );
                                          if (newTag) {
                                            setEmailAddressList([
                                              ...emailAddressList,
                                              newTag,
                                            ]);
                                          }
                                          setEmailAddress([]);
                                        } else {
                                          setEmailAddress(newVal);
                                        }
                                      }}
                                      disabled={isDisable}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div
                            className="teams table-responsive"
                            style={{ maxHeight: "inherit" }}
                          >
                            <table className="table table-bordered team_grid">
                              <tbody>
                                {emailAddressList.map((email, index) => (
                                  <tr key={index}>
                                    <td className="sharerecord">
                                      <SingleTagInputField
                                        label="Email Address"
                                        value={[email]}
                                        onChange={(newValue) => {
                                          const updatedList = [
                                            ...emailAddressList,
                                          ];
                                          updatedList[index] =
                                            newValue[0] || "";
                                          setEmailAddressList(updatedList);
                                        }}
                                        handleRemove={() =>
                                          handleRemoveEmails(index)
                                        }
                                        isEditable={true}
                                        disabled={isDisable}
                                      />
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </Col>
                      )}
                      <Col
                        sm={isShareWith ? 12 : 6}
                        className={isShareWith ? "mt-3" : ""}
                      >
                        <MultilineTextBox
                          label="Share Notes"
                          name="shareNotes"
                          value={shareNotes}
                          onChange={(e) => {
                            setShareNotes(e.target.value);
                          }}
                          className="sharerecodemultiline"
                          maxLength={100}
                          disabled={isDisable}
                        />
                      </Col>
                    </Row>
                  </>
                ),
              },
            ])}
          </>
        ) : (
          ""
        )}
        <Row className="mb-3 mt-3">
          <Col className="d-flex justify-content-start">
            <Button
              variant="outline"
              className="d-flex align-items-center btn-text-border me-1"
              onClick={handleBack}
            >
              <span className="material-icons mr-2 ">arrow_back</span>
              Back
            </Button>
          </Col>
          {headerActiveTab !== "Shared With Me" ? (
            <>
              <Col className="d-flex justify-content-end">
                <Button
                  variant="outline-info"
                  className="d-flex align-items-center m-0"
                  onClick={() => handleCancelButton("cancel2")}
                  disabled={isDisable}
                >
                  <span className="material-icons mr-2">close</span> Cancel
                </Button>
                <Button
                  type="submit"
                  variant="primary"
                  className="d-flex align-items-center mx-2"
                  onClick={handleSubmit}
                  disabled={isDisable}
                >
                  <span className="material-icons mx-1">share</span> Share
                </Button>
              </Col>
            </>
          ) : (
            ""
          )}
        </Row>
        <Modal show={showModalNew} onHide={handleCloseModalNew}>
          <Modal.Body className="fw-bold text-left modelheading ">
            <div>Are you sure you want to cancel?</div>
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCloseModalNew}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={handleConfirmCancelButton}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default CreateShareRecords;
